function restorePassword({ state, output, services }) {
  let password = state.get('login.recovery.restore.form.password.value')
  let _id = state.get('login.recovery.restore._id')
  services.Http
    .post('/api/user/restore/password', { _id: _id, password: password })
    .then(output.success)
    .catch(output.error)
}
restorePassword.outputs = ['success', 'error']

export default restorePassword



// WEBPACK FOOTER //
// ./src/modules/login/actions/restorePassword.js